/**
 * @todo: Once the whole project uses Lit, the dialog should be rendered in the .render method, and it should use
 * a portal to render the dialog outside of the component's shadow DOM.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AutomatorBuilderPublishRunNow_$runNowButton_accessor_storage;
// Import Lit dependencies
import { html, render, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
let AutomatorBuilderPublishRunNow = class AutomatorBuilderPublishRunNow extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * The dialogs that are currently open
         *
         * @type {HTMLElement[]}
         * @private
         */
        this._$dialogs = [];
        _AutomatorBuilderPublishRunNow_$runNowButton_accessor_storage.set(this, void 0);
    }
    /**
     * Query the button element
     *
     * @type {HTMLElement|null}
     * @private
     */
    get $runNowButton() { return __classPrivateFieldGet(this, _AutomatorBuilderPublishRunNow_$runNowButton_accessor_storage, "f"); }
    set $runNowButton(value) { __classPrivateFieldSet(this, _AutomatorBuilderPublishRunNow_$runNowButton_accessor_storage, value, "f"); }
    /**
     * Renders the component template.
     * @return {TemplateResult|undefined} The template result or undefined if the button shouldn't render.
     */
    render() {
        // Render the button only if the recipe has the "Run now" button
        if (!UncannyAutomator._recipe.miscellaneous.has_run_now) {
            // Return undefined for clarity when nothing is rendered
            return;
        }
        return html `
			<uo-button
				size="small"
				@click=${this.handleRunNow}
			>
				${_uo.utility.escHTML(wp.i18n.__('Run now', 'uncanny-automator'))}
			</uo-button>
		`;
    }
    /**
     * Invoked when the element is first updated after being connected to the DOM.
     * Checks if the recipe is editable and shows a dialog if not.
     */
    firstUpdated() {
        if (UncannyAutomator._recipe.miscellaneous.recipe_is_running) {
            this.renderRecipeRunningDialog();
        }
    }
    /**
     * Remove the dialogs when the component is disconnected from the DOM.
     *
     * @deprecated Remove this once the dialogs are rendered in the .render method
     */
    disconnectedCallback() {
        // Remove the dialogs from the list of open dialogs
        this._$dialogs.forEach($dialog => {
            // Remove the dialog from the DOM
            if (document.body.contains($dialog)) {
                $dialog.remove();
            }
        });
        // Clear the list of open dialogs
        this._$dialogs = [];
    }
    /**
     * Handles the "Run now" button click.
     * Ensures the recipe is published, then initiates the run.
     */
    async handleRunNow() {
        // If the recipe is not published, set it as published first and then run the recipe
        if (!UncannyAutomator._recipe.is_recipe_on) {
            // Set recipe as published
            try {
                await UncannyAutomator._core.recipe.setRecipeStatus(true);
            }
            catch (e) {
                // Log error
                console.error(e);
                // Stop here
                return;
            }
        }
        // Set loading animation on the button
        if (this.$runNowButton) {
            this.$runNowButton.loading = true;
        }
        else {
            console.error("Run now button not found when trying to set loading state.");
            return; // Cannot proceed without the button
        }
        // Do call to run recipe
        UncannyAutomator._core.recipe.runRecipe()
            .then((response) => {
            if (response.recipe_run_completed) {
                this.renderRecipeCompleteDialog();
            }
            else {
                this.renderRecipeRunningDialog();
            }
        })
            .catch(error => {
            console.error("Error running recipe:", error);
            if (this.$runNowButton) {
                this.$runNowButton.loading = false;
            }
        });
    }
    /**
     * Renders a dialog to inform the user that the recipe run has been initiated.
     */
    renderRecipeRunningDialog() {
        // Create the node that we'll use to render the dialog
        const wrapper = document.createElement('div');
        document.body.append(wrapper);
        // Add the dialog to the list of open dialogs
        this._$dialogs.push(wrapper);
        render(html `
				<uo-dialog
					open
					heading=${_uo.utility.escHTML(wp.i18n.__('The recipe run has been initiated', 'uncanny-automator'))}
					force-manual-close
				>
					<div style="margin-bottom: 15px">
						${_uo.utility.escHTML(wp.i18n.__('Actions are now running in the background and results will be available in the logs.', 'uncanny-automator'))}
					</div>

					<div style="margin-bottom: 15px">
						${_uo.utility.escHTML(wp.i18n.__("Changes cannot be made to the recipe while it's running. Progress can be monitored from the logs and actions that haven't run yet can be cancelled.", 'uncanny-automator'))}
					</div>

					<div style="margin-bottom: 15px">
						<uo-button
							color="primary"
							href="${UncannyAutomator._recipe.miscellaneous.url_logs}"
							target="_blank" >
							${_uo.utility.escHTML(wp.i18n.__('View log entry', 'uncanny-automator'))}
						</uo-button>
					</div>

					<div style="margin-bottom: 15px">
						${_uo.utility.escHTML(wp.i18n.__('You can also return to the list of recipes or create a copy of this recipe.', 'uncanny-automator'))}
					</div>

					<div>
						<uo-button
							color="secondary"
							href="${UncannyAutomator._site.automator.links.all_recipes}"
							style="margin-right: 10px"
						>
							${_uo.utility.escHTML(wp.i18n.__('Return to recipe list', 'uncanny-automator'))}
						</uo-button>

						<uo-button
							color="secondary"
							href="${UncannyAutomator._recipe.miscellaneous.url_duplicate_recipe}"
						>
						${_uo.utility.escHTML(wp.i18n.__('Duplicate this recipe', 'uncanny-automator'))}
						</uo-button>
					</div>
				</uo-dialog>
			`, wrapper);
    }
    /**
     * Renders a dialog to inform the user that the recipe run has been completed.
     */
    renderRecipeCompleteDialog() {
        // Create the node that we'll use to render the dialog
        const wrapper = document.createElement('div');
        document.body.append(wrapper);
        // Add the dialog to the list of open dialogs
        this._$dialogs.push(wrapper);
        render(html `
				<uo-dialog
					open
					heading=${_uo.utility.escHTML(wp.i18n.__('Recipe run complete', 'uncanny-automator'))}
				>
					<div style="margin-bottom: 15px">
						${_uo.utility.escHTML(wp.i18n.__('The recipe has already finished running. You can view the log entry to see the results. Once you close this dialog, you can continue editing the recipe.', 'uncanny-automator'))}
					</div>

					<uo-button
						color="primary"
						href="${UncannyAutomator._recipe.miscellaneous.url_logs}"
						target="_blank"
					>
						${_uo.utility.escHTML(wp.i18n.__('View log entry', 'uncanny-automator'))}
					</uo-button>

					<uo-button
						slot="primary-action"
						dialog-action="close"
						color="secondary"
					>
						${_uo.utility.escHTML(wp.i18n._x('Close', 'Verb', 'uncanny-automator'))}
					</uo-button>
				</uo-dialog>
			`, wrapper);
    }
};
_AutomatorBuilderPublishRunNow_$runNowButton_accessor_storage = new WeakMap();
__decorate([
    query('uo-button')
], AutomatorBuilderPublishRunNow.prototype, "$runNowButton", null);
AutomatorBuilderPublishRunNow = __decorate([
    customElement('uap-builder-publish-run-now-button') // eslint-disable-line require-jsdoc
], AutomatorBuilderPublishRunNow);
export { AutomatorBuilderPublishRunNow };
